import { FC, useState, useEffect, MouseEvent, useMemo } from 'react';
import {
  LoadingOutlined,
  PlusOutlined,
  DeleteOutlined,
  EyeOutlined,
} from '@ant-design/icons';
import { ProUpload, ProSpace } from '../../antd';
import Helper from '../../Helper';
import classNames from 'classnames';
import { getThumbUrl } from '../../utils/dataUtils';
import { minio_upload_api } from '../../api/oss/file';
import { UploadFile } from 'antd/lib/upload/interface';
import { MinioUploadImageProps } from '../interface';
import { SUCCESS_STATUS_CODE } from '../../constants/constant';

const UploadImage: FC<MinioUploadImageProps> = props => {
  const {
    wrapperClassName,
    uploadText,
    uploadIcon,
    fileList,
    uploadUrl,
    onChange,
    onReset,
    getPopupContainer,
    disabled,
    size,
    style,
    scene,
    hideImage,
    ...resProps
  } = props;
  const [currentFileList, setCurrentFileList] = useState<UploadFile<any>[]>();
  const [loading, setLoading] = useState<boolean>(false);
  useEffect(() => {
    if (fileList)
      setCurrentFileList(Array.isArray(fileList) ? fileList : undefined);
  }, [fileList]);
  // 点击删除图标
  const handleClick = (event: MouseEvent<HTMLSpanElement>) => {
    setCurrentFileList([]);
    onChange?.(undefined);
    event.preventDefault();
    event.stopPropagation();
  };
  // 点击查看大图图标
  const handlePreviewImage = (event: MouseEvent<HTMLSpanElement>) => {
    if (Array.isArray(currentFileList) && currentFileList.length) {
      const url = currentFileList[0].url;
      if (url) {
        Helper.previewImage({
          getPopupContainer,
          current: url,
          images: [url],
        });
      }
      event.preventDefault();
      event.stopPropagation();
    }
  };
  const uploadButton = (
    <div>
      {disabled && !currentFileList?.length ? (
        '暂无图片'
      ) : (
        <>
          {loading ? <LoadingOutlined /> : uploadIcon}
          {uploadText ? <div>{uploadText}</div> : null}
        </>
      )}
    </div>
  );
  const uploadClassName = useMemo(() => {
    return classNames(wrapperClassName || 'yb-upload', {
      'yb-upload-small': size === 'small',
    });
  }, [size, wrapperClassName]);
  
  return (
    <div
      className={size === 'default' ? '' : 'yb-upload-auto-size'}
      style={style}
    >
      <ProUpload
        name="file"
        disabled={disabled}
        listType="picture-card"
        className={uploadClassName}
        fileList={currentFileList}
        showUploadList={false}
        multiple={false}
        customRequest={async (currentParams: any) => {
          if (!uploadUrl) {
            await onReset?.();
          }
          const { data, filename, file } = currentParams;
          const params = new FormData();
          params.set(filename, file);
          const dataParams = {
            type: scene,
            compress: true,
            width: 100,
            height: 100,
            ...data,
          };
          if (dataParams) {
            for (let [key, value] of Object.entries(dataParams)) {
              params.set(key, value as string);
            }
          }
          setLoading(true);
          const res = await minio_upload_api(uploadUrl as string, params);
          setLoading(false);
          if (res.code === SUCCESS_STATUS_CODE) {
            const resData = res.data;
            const currentFileList = [
              {
                uid: file.uid,
                type: file.type,
                size: file.size,
                name: file.name,
                thumbUrl: getThumbUrl(resData.url),
                url: resData.url,
                ...resData,
              },
            ];
            setCurrentFileList(currentFileList);
            onChange?.(currentFileList);
            return;
          }
        }}
        {...resProps}
      >
        {!hideImage &&
        Array.isArray(currentFileList) &&
        currentFileList.length ? (
          <div className="yb-upload-image">
            <div className="yb-upload-image-delete">
              <ProSpace>
                <EyeOutlined
                  className="yb-upload-image-delete-big"
                  onClick={handlePreviewImage}
                />
                {!disabled && (
                  <DeleteOutlined
                    className="yb-upload-image-delete-icon"
                    onClick={handleClick}
                  />
                )}
              </ProSpace>
            </div>
            <img
              src={currentFileList[0].thumbUrl || currentFileList[0].url}
              style={{ width: '100%', height: '100%', objectFit: 'contain' }}
            />
          </div>
        ) : (
          uploadButton
        )}
      </ProUpload>
    </div>
  );
};

UploadImage.defaultProps = {
  uploadText: '点击上传',
  uploadIcon: <PlusOutlined />,
  size: 'default',
};

export default UploadImage;
